/* eslint-disable camelcase */
/* eslint-disable react/no-danger */
import { get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { ButtonInLink } from '@hivebrite/design-system/ButtonInLink';
import { CardWithTitle } from '@hivebrite/design-system/Card';
import { Divider } from '@hivebrite/design-system/Divider';
import { DefaultLink } from '@hivebrite/design-system/Link';

import { Event } from 'hb-react/frontoffice/components/CardEventsList';
import VideoPlayer from 'hb-react/frontoffice/components/VideoPlayer';
import Followings from 'hb-react/shared/apps/Topics/components/Followings';
import PartnersV2 from 'hb-react/shared/apps/Topics/components/Partners/PartnersV2';
import { useQueryTopicEvents } from 'hb-react/shared/apps/Topics/hooks/useQueryTopicEvents';
import UsersList from 'hb-react/shared/components/DesignSystem/UsersList';

const LinkedEventsWidget = ({ topic }) => {
  const { events } = useQueryTopicEvents({
    params: {
      per_page: 3,
    },
  });

  if (events.length === 0) {
    return null;
  }

  return (
    <CardWithTitle
      mb={6}
      title={I18n.t('web.topics.linked_events', {
        count: events.length,
      })}
    >
      {events.map((event, index) => {
        const isLastItem = index === events.length - 1;

        return (
          <EventWrapper key={event.id}>
            <Event
              cancelled={event.cancelled}
              new_cover_picture={event.new_cover_picture}
              start_date={event.start_date}
              id={event.id}
              title={event.title}
              type={event.type}
              timezone={event.timezone}
            />
            {!isLastItem && <Divider mt={3} mb={0} />}
          </EventWrapper>
        );
      })}

      {events.length > 3 && (
        <ButtonWrapper>
          <ButtonInLink
            linkProps={{
              to: Routes.topic_events_path(topic.id),
            }}
          >
            {__('See all events')}
          </ButtonInLink>
        </ButtonWrapper>
      )}
    </CardWithTitle>
  );
};

const TopicHomeGeneralInfosContainer = (props) => {
  const { expert_store, following_store, link_store, partner_store, topic } =
    props;

  return (
    <Box display="block" p={{ _: 5, l: 0 }}>
      {(topic.description || topic.video_url) && (
        <CardWithTitle mb={6} title={I18n.t('web.topics.description')}>
          <StyledBox>
            {topic.description && (
              <div dangerouslySetInnerHTML={{ __html: topic.description }} />
            )}
            {topic.video_url && <VideoPlayer controls url={topic.video_url} />}
          </StyledBox>
        </CardWithTitle>
      )}
      {!isEmpty(topic.partners) && (
        <CardWithTitle
          mb={6}
          title={
            get(
              topic,
              ['home_config', 'section_partners_title'],
              __('Partners'),
            ) ||
            I18n.t('web.topics.partners', {
              count: topic.partners.length,
            })
          }
        >
          <PartnersV2
            partners={topic.partners.map((partnerId) =>
              partner_store.getIn(['partners', partnerId.toString()]).toJS(),
            )}
          />
        </CardWithTitle>
      )}
      {!isEmpty(topic.experts) && (
        <UsersList
          isFullWidth
          numberOfUsersDisplayed={topic.experts.length}
          mb={6}
          pt={4}
          px={6}
          title={
            topic.expert_title ||
            ns__('Topics|Contact', 'Topics|Contacts', topic.experts.length)
          }
          users={topic.experts.map((expertId) => {
            const expert = expert_store
              .getIn(['experts', expertId.toString()])
              .toJS();

            expert.id = expert.user_id;

            return expert;
          })}
        />
      )}
      {/* Used for mobile view */}
      {!isEmpty(topic.followings) && (
        <Followings
          followings={topic.followings.map((followingId) =>
            following_store.getIn(['followings', followingId.toString()]),
          )}
          total={following_store.get('total')}
          topic_id={topic.id}
          sidebar_rendering
        />
      )}
      <LinkedEventsWidget topic={topic} />

      {!isEmpty(topic.links) && (
        <CardWithTitle
          mb={6}
          title={I18n.t('web.topics.links', {
            count: topic.links.length,
          })}
        >
          <StyledBox>
            {topic.links.map((linkId, index) => {
              const link = link_store.getIn(['links', linkId.toString()]);

              return (
                <DefaultLink
                  href={link.get('url')}
                  key={link.get('id')}
                  mb={index === topic.links.length - 1 ? 0 : 4}
                  enableWrap
                  target="_blank"
                >
                  {link.get('title')}
                </DefaultLink>
              );
            })}
          </StyledBox>
        </CardWithTitle>
      )}
    </Box>
  );
};

TopicHomeGeneralInfosContainer.propTypes = {
  topic: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  expert_store: state.experts,
  following_store: state.followings,
  partner_store: state.partners,
  link_store: state.links,
});

export default connect(mapStateToProps)(TopicHomeGeneralInfosContainer);

const StyledBox = styled(Box).attrs(() => ({
  flexDirection: 'column',
}))`
  > div {
    margin-bottom: 12px;

    p:last-child {
      margin: 0;
    }
  }
`;

const EventWrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  mt: 4,
}))``;

const ButtonWrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'center',
  pt: 6,
  width: '100%',
}))``;
